import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpResponse,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Injectable } from '@angular/core';
import { deleteCookie } from './shared/functions/coockie';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        private toaster: ToastrService,
    ) {

    }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let errMsg = '';
                    if (error.status == 403) {
                        let urls = this.router.url.split('/');
                        if (urls && urls.length > 2 && urls[2] == 'membership')
                            localStorage.setItem('membership_invite', this.router.url);
                        this.toaster.warning("You are not Logged in. Please login First", "Error");
                        deleteCookie('token');
                        this.router.navigateByUrl('/');
                    } else if (error.status == 404) {
                        this.toaster.error("404, API not found error.", "Error");
                    } else if (error.error instanceof ErrorEvent) {
                        errMsg = `Error: ${error.error.message}`;
                    } else if (error.error && error.error.error_obj) {
                       return throwError(error.error);
                    } else {
                        errMsg = `Error Code: ${error.status},  Message: ${error.message}`;
                    }
                    return throwError(errMsg);
                })
            )
    }
}
